export const normalizeStoreActivationSession = ({ context = {} }: any): any => {
  const { clientToken, klarnaSessionBody, paymentMethodCategory } = context

  return {
    clientToken,
    klarnaSessionBody,
    paymentMethodCategory,
  }
}

export const normalizeStoreActivationInfo = (storeActivationInfoResponse): any =>
  storeActivationInfoResponse?.[0].link?.[0]
